import { defineComponent as _defineComponent } from 'vue'
import { computed, watch, toRefs } from "vue";
import Dialog from "@/components/vuetify-wrappers/NjDialog.vue";
import Select from "@/components/vuetify-wrappers/Select.vue";
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { ApiService, LogService, SnackbarService } from "@/services";
import { useSessionStore } from "@/pinia/session";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'DossierDownloadDialog',
  props: {
    display: { type: Boolean },
    profileCount: null,
    checking: { type: Boolean },
    orderSelection: null,
    formatSelection: null,
    useCustomLogo: { type: Boolean },
    quickDownload: { type: Boolean },
    isSelectionActive: { type: Boolean, default: false },
    hasIneligibleItems: { type: Boolean }
  },
  emits: [
  "update:display",
  "update:order",
  "update:format",
  "update:logo",
  "calculate",
],
  setup(__props: any, { emit }) {

const props = __props as { display: boolean, profileCount: number, checking: boolean, orderSelection: string, formatSelection: string, useCustomLogo: boolean, quickDownload?: boolean, isSelectionActive: boolean, hasIneligibleItems?: boolean };

const route = useRoute();
const isBriefcasePage = computed(() => route.fullPath.includes("briefcase"));

const sessionStore = useSessionStore();
const hasCustomLogo = computed(() => sessionStore.hasCustomLogo);

// Props

// watcher to initiate the refresh when the dialog is opened
watch(
  () => props.display,
  (val) => {
    val && initiateRefresh();
  }
);
const initiateRefresh = () => {
  emit("calculate");
};
const {
  isSelectionActive,
  hasIneligibleItems,
  quickDownload,
  checking,
  orderSelection,
  formatSelection,
  useCustomLogo,
} = toRefs(props);



const downloadFormatOptions = [
  { id: "docx", name: "Microsoft Word (single document)" },
  { id: "zip_docx", name: "Microsoft Word (ZIP with separate files)" },
  { id: "pdf", name: "PDF (single document)" },
  { id: "zip_pdf", name: "PDF (ZIP with separate files)" },
];

const sortOrderItems = [{ id: "alphabetical", name: "Alphabetical" }];
if (isBriefcasePage.value) {
  sortOrderItems.unshift({ id: "folderbriefcase_id", name: "As in briefcase" });
}
const filteredSortOrderItems = computed(() => {
  return isSelectionActive.value
    ? [{ id: "folderbriefcase_id", name: "As in briefcase" }]
    : sortOrderItems;
});

function requestCustomLogo() {
  ApiService.postUserContact("", true).then((response) => {
    if (response.statusCode === 200) {
      LogService.info(`Profile.requestCustomLogo is successful.`);
      SnackbarService.displaySnackbar(
        "Request for custom logo successfully submitted.",
        "primary"
      );
    } else {
      LogService.error(
        `Profile.requestCustomLogo failed: '${response.error_message}'`
      );
      SnackbarService.displaySnackbar("An error occurred, please try again.");
    }
  });
}

return { __sfc: true,route, isBriefcasePage, sessionStore, hasCustomLogo, props, initiateRefresh, isSelectionActive, hasIneligibleItems, quickDownload, checking, orderSelection, formatSelection, useCustomLogo, emit, downloadFormatOptions, sortOrderItems, filteredSortOrderItems, requestCustomLogo, Dialog, Select, NjBtn }
}

})